import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { currencySymbol } from 'app/helpers/money';
import { FormContext, useContext } from './useFormContext';

const LimitedAmount: FC<{ context: FormContext; value: string; onChange: (v: string) => void; currency: string }> = ({
  context,
  value,
  onChange,
  currency,
}) => (
  <div style={{ margin: '0.5em 0 5em' }} className="rs-flex">
    {context.extra.vendor_amounts.map((v) => (
      <div className="rs-flex-item rs-small-3" key={v}>
        <label style={{ lineHeight: '1.5' }}>
          <input
            style={{ margin: '0' }}
            type="radio"
            value={v}
            name={context.amountFieldName}
            checked={v === +value}
            onChange={(e) => onChange(e.target.value)}
          />
          &nbsp;{currencySymbol(currency)}
          {v}
        </label>
      </div>
    ))}
  </div>
);

const UnlimitedAmount: FC<{ context: FormContext; value: string; onChange: (v: string) => void; currency: string }> = ({
  context,
  value,
  onChange,
  currency,
}) => (
  <div className="rs-flex rs-flex_collapse">
    <div className="rs-flex-item rs-small-1">
      <span className="prefix" data-currency={currency}>
        {currencySymbol(currency)}
      </span>
    </div>
    <div className="rs-flex-item rs-small-11">
      <input
        type="number"
        step="any"
        value={value}
        id={context.amountFieldName}
        name={context.amountFieldName}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  </div>
);

const Amount: FC<{
  value: string;
  onChange: (v: string) => void;
  currency: string;
  error: boolean;
}> = ({ value, onChange, currency, error }) => {
  const context = useContext();

  const label = context.isDeposit
    ? context.locales.deposit_form_amount_label
    : context.locales.withdrawal_form_amount_label;

  return (
    <div className={classnames({ error }, 'rs-column-small-12 input')}>
      <label htmlFor={context.amountFieldName}>{`${label}:`}</label>
      <div className="amount">
        {context.isAmountLimited ? (
          <LimitedAmount context={context} value={value} onChange={onChange} currency={currency} />
        ) : (
          <UnlimitedAmount context={context} value={value} onChange={onChange} currency={currency} />
        )}
      </div>
    </div>
  );
};

export default Amount;
